import { isInfant } from '@/shared/lib/touristAge';
import type { SearchCriteria, TouristRoom, PartialSearchCriteria } from '../../model/types';

export interface NormalizedGroup {
  adults: number;
  kids?: number;
  infants?: number;
  ages?: number[];
}

export interface TouristGroupParams {
  adults?: number;
  kids?: number;
  infants?: number;
  ages?: number[];
  rooms?: NormalizedGroup[];
}

function normalizeGroup(room: TouristRoom): NormalizedGroup {
  const ages = Array.isArray(room.childrenAges) ? room.childrenAges : [];
  const infants = ages.filter((age) => isInfant(age)).length;
  const kids = ages.length - infants;

  const result: NormalizedGroup = { adults: room.adults };
  if (kids) {
    result.kids = kids;
  }
  if (infants) {
    result.infants = infants;
  }
  if (ages.length) {
    result.ages = ages;
  }

  return result;
}

export function touristGroup(criteria: SearchCriteria | PartialSearchCriteria): TouristGroupParams | null {
  const tourists = criteria.tourists;
  if (!tourists || !Array.isArray(tourists.rooms) || tourists.rooms.length === 0) {
    return null;
  }

  const { rooms } = tourists;
  if (rooms.length > 1) {
    return { rooms: rooms.map((room) => normalizeGroup(room)) };
  }

  return normalizeGroup(rooms[0]);
}
